import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import authentification from "./modules/authentification";
import langage from "./modules/langage";
import popup from "./modules/popup";
import evenement from "./modules/evenement";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    authentification: {
      userToken: state.authentification.userToken,
      initSearch: state.authentification.initSearch,
      connectUserID: state.authentification.connectUserID,
      connectUserEmail: state.authentification.connectUserEmail,
      isLogged: state.authentification.isLogged,
      idEntreprise: state.authentification.idEntreprise,
      idPlateforme: state.authentification.idPlateforme,
      iframeColidee: state.authentification.iframeColidee,
      idEventColidee: state.authentification.idEventColidee
    },
    langage: {
      langue: state.langage.langue
    },
    evenement: {
      configure_links_evenement: state.evenement.configure_links_evenement,
      configure_links_evenement_name:
        state.evenement.configure_links_evenement_name
    }
  })
});

Vue.use(Vuex);

export default window.store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    authentification,
    langage,
    popup,
    evenement
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js